// Render types only – used by DynamicCell to choose how to render (not column identity).
export const CELL_TYPES = {
  TEXT: 'text',
  PRODUCT: 'product',
  COMPANY: 'company',
  DATE: 'date',
  LAST_USER_CONFIRMATION: 'lastUserConfirmation',
  LINK: 'link',
  CUSTOM: 'custom',
}

// Product cell layout – column setting for PRODUCT cellType.
export const PRODUCT_LAYOUTS = {
  WITH_COMPANY: 'withCompany',
  FULL: 'full',
}

// Column identity strings – used for slots (e.g. header-cell-*), col.name checks, sortBy. Single source of truth.
export const TABLE_COL_NAMES = {
  PRODUCT_NAME: 'productName',
  DATE_CREATED: 'dateCreated',
  DATE_SUBMITTED: 'dateSubmitted',
  LAST_USER_CONFIRMATION: 'lastUserConfirmation',
  CHECKBOX: 'checkbox',
  ACTIONS: 'actions',
  PRODUCT: 'product',
  TITLE: 'title',
  COMPANY: 'company',
  COMPANY_NAME: 'companyName',
  LINK: 'link',
  SCORE: 'score',
  NUMBER_OF_PRODUCTS: 'numberOfProducts',
}

// Shared table column definitions to avoid duplication across different tables.
// name = column identity (slots, keys); cellType = how DynamicCell renders; layout etc.
export const TABLE_COLUMN_DEFINITIONS = {
  productName: {
    name: TABLE_COL_NAMES.PRODUCT_NAME,
    label: 'Product',
    field: 'productName',
    align: 'left',
    sortable: true,
    classes: 'product-name main-td',
    headerClasses: 'product-name main-td',
    cellType: CELL_TYPES.PRODUCT,
    layout: PRODUCT_LAYOUTS.WITH_COMPANY,
  },
  dateCreated: {
    name: TABLE_COL_NAMES.DATE_CREATED,
    label: 'Created on',
    field: 'dateCreated',
    align: 'right',
    sortable: true,
    classes: 'date sm-td',
    headerClasses: 'date sm-td',
    cellType: CELL_TYPES.DATE,
  },
  dateSubmitted: {
    name: TABLE_COL_NAMES.DATE_SUBMITTED,
    label: 'Submitted on',
    field: 'dateSubmitted',
    align: 'left',
    sortable: true,
    classes: 'date sm-td',
    headerClasses: 'date sm-td',
    cellType: CELL_TYPES.DATE,
  },
  lastUserConfirmation: {
    name: TABLE_COL_NAMES.LAST_USER_CONFIRMATION,
    label: 'Confirmed on',
    field: 'lastUserConfirmation',
    align: 'left',
    sortable: true,
    classes: 'last-confirmation sm-td',
    headerClasses: 'last-confirmation sm-td',
    cellType: CELL_TYPES.LAST_USER_CONFIRMATION,
  },
  checkbox: {
    name: TABLE_COL_NAMES.CHECKBOX,
    label: '',
    field: 'approvalId',
    align: 'left',
    headerClasses: 'checkbox',
    classes: 'checkbox',
    cellType: CELL_TYPES.CUSTOM,
  },
  actions: {
    name: TABLE_COL_NAMES.ACTIONS,
    label: '',
    field: 'actions',
    align: 'right',
    headerClasses: 'actions',
    classes: 'actions',
    cellType: CELL_TYPES.CUSTOM,
  },
  product: {
    name: TABLE_COL_NAMES.PRODUCT,
    align: 'left',
    classes: 'product main-td',
    cellType: CELL_TYPES.PRODUCT,
    layout: PRODUCT_LAYOUTS.FULL,
    showPolicyBadge: true,
  },
  title: {
    name: TABLE_COL_NAMES.TITLE,
    field: 'productName',
    align: 'left',
    classes: 'product main-td',
    cellType: CELL_TYPES.TEXT,
    showPolicyBadge: true,
  },
  company: {
    name: TABLE_COL_NAMES.COMPANY,
    align: 'left',
    classes: 'company main-td',
    cellType: CELL_TYPES.COMPANY,
    showPolicyBadge: true,
  },
  link: {
    name: TABLE_COL_NAMES.LINK,
    align: 'left',
    classes: 'link lg-td',
    cellType: CELL_TYPES.LINK,
  },
  score: {
    name: TABLE_COL_NAMES.SCORE,
    field: 'score',
    align: 'right',
    classes: 'score md-td',
    cellType: CELL_TYPES.TEXT,
    format: (val) => (parseInt(val) || 0) + '% match',
    contentClass: 'q-ma-none text-12 text-primary text-font-regular',
  },
  numberOfProducts: {
    name: TABLE_COL_NAMES.NUMBER_OF_PRODUCTS,
    label: 'Number of products',
    field: 'listOfProducts',
    align: 'left',
    classes: 'number-of-products sm-td',
    headerClasses: 'number-of-products sm-td',
    cellType: CELL_TYPES.TEXT,
    format: (val) => {
      const count = Object.keys(val || {}).length
      return count + ' ' + (count === 1 ? 'product' : 'products')
    },
    contentClass: 'q-ma-none text-12 text-info text-font-regular',
  },
}
